module.exports = __webpack_public_path__ + "img/file-spreadsheet.d8989c57.svg";